import { useContext, useEffect, useState } from 'react';
import { changeWebPageTitleService } from '../../../infrastructure/services';
import { Private_Routes } from '../../../main/constants';
import { AppContext } from '../../../main/context/Provider';
import { ContactForm } from '../components/form/ContactsForm';
import { useParams } from 'react-router-dom';
import { Contact } from '../../../domain/customerContact/Contact';
import { ContactRepository } from '../../../infrastructure/repositories/customer-contacts/contactRepository';

export const CreateContactPage = () => {
    const { setNestedRoutes, isSkinSmart, lang } = useContext(AppContext);
    const [contact, setContact] = useState<Contact>();
    const { webPage } = changeWebPageTitleService(isSkinSmart, 'Nuevo Contacto ');
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        if (id) {
            ContactRepository.GetContact(id).then((response) => {
                setContact(response);
                setNestedRoutes([
                    {
                        label: 'Contactos',
                        route: `/customers/contacts/contacts-list/${response?.customerId}`,
                    },
                    {
                        label: webPage,
                        route: `/customers/contacts/update-contact/${id}`,
                    },
                ]);
            });
        }
    }, [id, lang, setNestedRoutes, webPage]);

    return <ContactForm isNewContact={true} />;
};
